import React from "react";
import Page from "../../common/page/Page";
import useTranslationEmailSubscription from "../useTranslationEmailSubscription";
import SpotterUnsubscriptionBlock from "./SpotterUnsubscriptionBlock";
import useShowLoader from "../../common/loading-widgets/useShowLoader";
import { useParams } from "react-router";

export default function SpotterUnsubscriptionPage(/*props*/) {
  // Fetch the email provided in the url params.
  const urlParams = useParams();
  const email = urlParams.email;

  const { t, loading: tLoading } = useTranslationEmailSubscription();
  useShowLoader(tLoading, "SpotterUnsubscriptionPage");

  return (
    <Page className="SpotterUnsubscriptionPage">
      <Page.Title
        text={t("email-subscription:email_unsubscription_Spotter_title")}
        loading={tLoading}
      />
      <Page.Content>
        <SpotterUnsubscriptionBlock email={email} />
      </Page.Content>
    </Page>
  );
}
